import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// Auth views
import Login from '@/views/auth/Login.vue'
import Register from '@/views/auth/Register.vue'
import VerifyAccount from '@/views/auth/VerifyAccount.vue'
import ForgotPassword from '@/views/auth/ForgotPassword.vue'
import LandingPage from '@/views/LandingPage.vue'
import PrivacyPolicy from '@/views/legal/PrivacyPolicy.vue'
import ContactUs from '@/views/legal/ContactUs.vue'

// Layout
import AppLayout from '@/components/layout/AppLayout.vue'

// App views (lazy-loaded)
const Dashboard = () => import('@/views/dashboard/DashboardView.vue')
const Shops = () => import('@/views/shops/ShopsView.vue')
const Services = () => import('@/views/services/ServicesView.vue')
const Bookings = () => import('@/views/bookings/BookingsView.vue')
const BookingSlots = () => import('@/views/bookings/BookingSlotsView.vue')
const Stylists = () => import('@/views/stylists/StylistsView.vue')
const Queue = () => import('@/views/queue/QueueView.vue')

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Landing', component: LandingPage, meta: { public: true, title: 'Book beauty appointments faster' } },

  // Public auth routes
  { path: '/login',           name: 'Login',          component: Login,          meta: { public: true, title: 'Sign In' } },
  { path: '/register',        name: 'Register',       component: Register,       meta: { public: true, title: 'Create Account' } },
  { path: '/verify-account',  name: 'VerifyAccount',  component: VerifyAccount,  meta: { public: true, title: 'Verify Account' } },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword, meta: { public: true, title: 'Reset Password' } },
  { path: '/legal/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy, meta: { public: true, title: 'Privacy Policy' } },
  { path: '/legal/contact-us', name: 'ContactUs', component: ContactUs, meta: { public: true, title: 'Contact Us' } },

  // Protected app routes (wrapped in AppLayout)
  {
    path: '/app',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '',           redirect: { name: 'Dashboard' } },
      { path: 'dashboard',  name: 'Dashboard',    component: Dashboard,    meta: { title: 'Dashboard' } },
      { path: 'shops',      name: 'Shops',         component: Shops,        meta: { title: 'My Shops' } },
      {
        path: 'shops/:shopId/bookings',
        name: 'Bookings',
        component: Bookings,
        meta: { title: 'Bookings' }
      },
      {
        path: 'shops/:shopId/services',
        name: 'Services',
        component: Services,
        meta: { title: 'Services' }
      },
      {
        path: 'shops/:shopId/stylists',
        name: 'Stylists',
        component: Stylists,
        meta: { title: 'Stylists' }
      },
      {
        path: 'shops/:shopId/queue',
        name: 'Queue',
        component: Queue,
        meta: { title: 'Live Queue' }
      },
      {
        path: 'shops/:shopId/booking-slots',
        name: 'BookingSlots',
        component: BookingSlots,
        meta: { title: 'Booking Slots' }
      }
    ]
  },

  // Catch-all redirect
  { path: '*', redirect: { name: 'Landing' } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes
})

// Navigation guard
router.beforeEach((to, _from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  if (!to.meta.public && !isAuthenticated) {
    next({ name: 'Login' })
  } else if (to.meta.public && isAuthenticated && ['Login', 'Register'].includes(to.name)) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

router.afterEach((to) => {
  const routeTitle = to.meta?.title
  document.title = routeTitle ? `ubuHle | ${routeTitle}` : 'ubuHle'
})

export default router
